import { SuspensePage } from '@/shared/ui/layout/SuspensePage';
import { PagesPrivacyMain } from './modules/ui/Main';

const PrivacyPage = (
  <SuspensePage>
    <PagesPrivacyMain />
  </SuspensePage>
);

export default PrivacyPage;
